import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from '@knockrentals/knock-shared-web-v2';
import { makeCss } from '../../make-css';

const useCss = makeCss({
  featurePage: {
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100vh - 116px)',
    width: 'calc(100vw - 255px)',
    '& hr': { marginTop: 'unset' },
  },
});

const PageContainer = ({ children, className }) => {
  const css = useCss();

  return (
    <ThemeProvider>
      <section className={className} css={css.featurePage}>
        {children}
      </section>
    </ThemeProvider>
  );
};

PageContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default PageContainer;
